// extracted by mini-css-extract-plugin
export default {"button":"hide-menu_button__a5Udu","modal":"hide-menu_modal__n014+","menuItem":"hide-menu_menuItem__Hn9Sc","reportButton":"hide-menu_reportButton__e7L2O"};